// extracted by mini-css-extract-plugin
export default {"sideMenuContainer":"SideMenu_sideMenuContainer__+4iTw","active":"SideMenu_active__Dq2vX"};